import React from 'react'
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldError,
  RegisterOptions,
} from 'react-hook-form'
import { TextField, TextFieldProps } from '@material-ui/core'

type Props = Omit<TextFieldProps, 'error'> & {
  control: Control
  name: string
  defaultValue?: string
  rules?: RegisterOptions
  error?: FieldError
  dataCy?: string
  validateOnBlur?: boolean
}

export function ControlledTextField(props: Props): React.ReactElement {
  const {
    control,
    name,
    defaultValue,
    rules,
    error,
    dataCy,
    onChange: onChangeFromProps,
    onBlur: onBlurFromProps,
    validateOnBlur,
    ...inputProps
  } = props

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ''}
      rules={rules}
      render={({
        value,
        onChange,
        onBlur,
      }: Omit<ControllerRenderProps, 'value'> & { value: string }) => (
        <TextField
          {...inputProps}
          name={name}
          value={value}
          onChange={(event) => {
            onChange(event.target.value)

            if (onChangeFromProps) {
              onChangeFromProps(event)
            }
          }}
          onBlur={(event) => {
            if ({ ...props }.validateOnBlur ?? false) onBlur()

            if (onBlurFromProps) onBlurFromProps(event)
          }}
          error={Boolean(error)}
          helperText={error?.message}
          data-cy={dataCy}
        />
      )}
    />
  )
}
